/**
 * Stringify a location-kind custom field stub for CSV / plain-text display.
 * Stub shape matches location custom-field projection subpaths (`name`, `locationPath`).
 */

import { formatLocationPath } from './format-location-path';

export type LocationCustomFieldExportValue = {
	name?: string | null;
	locationPath?: Array<{ name?: string | null }> | null;
};

export type FormatLocationCustomFieldForExportOptions = {
	/**
	 * When true (location hierarchy on), prefer a leveled path over `name`.
	 * When false, always use `name` (same rule as the system Location CSV column).
	 */
	locationHierarchyEnabled?: boolean;
};

export const formatLocationCustomFieldForExport = (
	value: unknown,
	{ locationHierarchyEnabled = false }: FormatLocationCustomFieldForExportOptions = {}
): string => {
	if (typeof value !== 'object' || value === null) {
		return '';
	}

	const location = value as LocationCustomFieldExportValue;

	if (locationHierarchyEnabled) {
		return formatLocationPath(location.locationPath, location.name ?? undefined) ?? '';
	}

	return location.name ?? '';
};
